export const apiCreate = (): string => '/cache/create'
export const apiList = (id?: string): string =>
  !id ? '/cache/' : `/cache/view/${id}`
export const apiUpdate = (id: string): string => `/cache/update/${id}`
export const apiDelete = (id: string): string => `/cache/delete/${id}`
